import { Component, Inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GeneralConfirmationModalResult } from "../../models";
import { AccountService } from "../../services/account.service";
import { VerifiableUserAttributeKey } from "aws-amplify/auth";

const RESEND_COOLDOWN_SECONDS = 30;

@Component({
  selector: 'cpf-account-attribute-change-modal',
  templateUrl: './account-attribute-change-modal.component.html',
  styleUrls: ['./account-attribute-change-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AccountAttributeChangeModalComponent implements OnDestroy {
  code = '';
  resending = false;
  resendCooldown = 0;
  resendError = false;
  public GeneralConfirmationModalResult = GeneralConfirmationModalResult;

  private cooldownInterval?: ReturnType<typeof setInterval>;

  constructor(public dialogRef: MatDialogRef<AccountAttributeChangeModalComponent>,
              private accountService: AccountService,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  private get userAttributeKey(): VerifiableUserAttributeKey {
    return this.data?.userAttributeKey ?? 'email';
  }

  confirm() {
    this.dialogRef.close(this.code);
  }

  close(result: GeneralConfirmationModalResult) {
    this.dialogRef.close(result);
  }

  async resendCode() {
    if (this.resending || this.resendCooldown > 0) {
      return;
    }

    this.resending = true;
    this.resendError = false;

    const res = await this.accountService.handleSendUserAttributeVerificationCode({
      userAttributeKey: this.userAttributeKey
    });

    this.resending = false;

    if (res === 'error') {
      this.resendError = true;
      return;
    }

    this.startCooldown();
  }

  private startCooldown() {
    this.resendCooldown = RESEND_COOLDOWN_SECONDS;
    this.cooldownInterval = setInterval(() => {
      this.resendCooldown -= 1;
      if (this.resendCooldown <= 0) {
        this.clearCooldown();
      }
    }, 1000);
  }

  private clearCooldown() {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
      this.cooldownInterval = undefined;
    }
  }

  ngOnDestroy() {
    this.clearCooldown();
  }
}
